import { CONTROL_TYPES } from "Core/Constant";
import { GenericButton } from "Core/Controls/GenericButton/GenericButton";
import { Grid } from "Core/Controls/Grid/Grid";
import { screenFacade } from "Core/Components/CustomFunctions/Facades/ScreenFacade";
import { IFrameExtension } from "../../../Controls/IFrameExtension/IFrameExtension";

export const frameExtensionFacade = (control: IFrameExtension) => {
    const screen = screenFacade(control.Screen);
    return { screen }
}